import { takeLatest } from "redux-saga/effects";
import { getTenantUserListSaga, deleteUserRowRequestSaga, updateUserRowRequestSaga } from "./saga";
import { GET_TENANT_USER_LIST_REQUEST, DELETE_USER_ROW_REQUEST, UPDATE_USER_ROW_REQUEST } from "../consts";

export default function* watchTenantUserList() {
  yield takeLatest(GET_TENANT_USER_LIST_REQUEST, getTenantUserListSaga);
  yield takeLatest(DELETE_USER_ROW_REQUEST, deleteUserRowRequestSaga);
  yield takeLatest(UPDATE_USER_ROW_REQUEST, updateUserRowRequestSaga);
}
